import React from 'react';
import PropTypes from 'prop-types';
// import useTheme from 'modules/auth/hooks/useTheme';

export const LayoutContext = React.createContext();

function AppWrapper({ partner, children }) {
  // const [theme] = useTheme();
  return (
    <LayoutContext.Provider value={{}}>
      <div
        className="max-w-lg w-full mx-auto flex flex-col h-full bg-no-repeat bg-cover bg-center"
        style={{ backgroundImage: `url(${partner?.bg_lobby_url})` }}
      >
        {children}
      </div>
    </LayoutContext.Provider>
  );
}

AppWrapper.defaultProps = {
  partner: {},
  children: null,
};

AppWrapper.propTypes = {
  partner: PropTypes.instanceOf(Object),
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default AppWrapper;
